import React from 'react';
import type { CompanyProfileDataTable } from '../../utils/company/build-company-profile-data-tables';

export interface CompanyProfileSeoTablesProps {
  /** Screen-reader-only / crawler-friendly tables; keep in sync with visible charts */
  tables: CompanyProfileDataTable[];
  /** Shown only to assistive tech (Tailwind sr-only) */
  visuallyHiddenHeading: string;
}

/**
 * Semantic HTML tables with captions — hidden visually but present in the DOM for search engines and SR.
 */
export function CompanyProfileSeoTables({ tables, visuallyHiddenHeading }: CompanyProfileSeoTablesProps) {
  if (tables.length === 0) return null;

  return (
    <section className="sr-only" aria-label={visuallyHiddenHeading}>
      <h2>{visuallyHiddenHeading}</h2>
      {tables.map((table, ti) => (
        <table key={ti} className="w-full text-left text-sm">
          <caption className="text-left font-semibold">{table.caption}</caption>
          <thead>
            <tr>
              {table.headers.map((h) => (
                <th key={h} scope="col">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((row, ri) => (
              <tr key={ri}>
                {row.map((cell, ci) => (
                  <td key={ci}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ))}
    </section>
  );
}
